/** @jsx jsx */
import { jsx } from "theme-ui"
import styled from "styled-components"
import Checkbox from "@components/form/Checkbox"
import theme, { rem } from "@src/theme"
const CheckboxGroup = ({
  options,
  currentValue,
  setFieldValue,
  error,
  required,
  label,
  name,
  wrapperClass
}) => (
  <Wrapper className={wrapperClass}>
    {label && (
      <label className="field-label">
        <span>
          {label}
          {required && "*"}
        </span>

        {options.map(({ label, value }, index) => (
          <Checkbox
            name={name}
            value={value}
            label={label}
            setFieldValue={setFieldValue}
            fieldValue={currentValue}
          />
        ))}
      </label>
    )}

    {error && <p sx={{ color: "rainbowRed", mt: 1, mb: 0 }}>{error}</p>}
  </Wrapper>
)

export default CheckboxGroup

const Wrapper = styled.fieldset`
  > label {
    font-weight: 900;
    margin-bottom: 0 !important;
    span {
      display: block;
      margin-bottom: ${rem(14)};
    }
    label {
      margin-bottom: ${rem(5)};
      font-family: ${theme.fonts.body};
      font-weight: 500;
      text-transform: initial;

      &:last-child {
        margin-bottom: ${rem(0)};
      }
    }
  }
`
